import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Mask, Button, Dialog, Toast, Toptips } from 'react-weui'
import Clipboard from 'clipboard'
import { renderMoney, TimeStream } from '../../utils'
import Header from '../../components/liveroomLecturer/Header'
import { Page, WKTab } from '../../components'
import { WKSearch, WkPanel, WKVisible, WKInfiniteScroll } from '../../components/wk'
import MediaItem from './MediaItem'
import ResellNoItem from './ResellNoItem'
import '../../css/page/ResellPage.css'
import questionImg from '../../images/question.png'
import wxMomentImg from '../../images/wx-moment.png'
import wxMenuImg from '../../images/wx-menu.png'


class ResellLiveroomPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowQuestionModal: false,
            inviteTotal: '',

            invites: [],
            invitesOffset: 0,
            invitesHasMore: true,
            invitesIsPending: false,
        }
    }
    componentDidMount () {
        this.fetchInvites()
    }
    fetchInvites () {
        this.setState({ invitesIsPending: true })
        axios.get(`/api/resell/liveroom/${this.props.params.id}/invite_list`, {
            params: {
                offset: this.state.invitesOffset,
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    invites: this.state.invites.concat(data.invites),
                    invitesHasMore: data.has_more,
                    invitesIsPending: false,
                    invitesOffset: data.next_offset,
                    inviteTotal: data.invite_total,
                })
            })
    }
    render() {
        const { invites } = this.state
        return (
            <div className='invites-page'>
                <ResellNoItem 
                    show={this.state.inviteTotal === 0}
                    text='暂无邀请记录，继续努力吧'
                />
                <WKVisible create={this.state.inviteTotal > 0}>
                    <div className="topbar wk-border-line-after wk-position-rlt">
                        <div className="name">累计已邀请{this.state.inviteTotal}人</div>
                        <div className="question" onClick={e => this.setState({ isShowQuestionModal: true })}>
                            <img src={questionImg} alt=""/>
                        </div>
                    </div>
                </WKVisible>
                {
                    invites.map(item => (
                        <MediaItem
                            key={item.account.id}
                            content={{
                                cover: item.account.avatar_url,
                                topText: item.account.nickname,
                                middleText: `邀请时间：${TimeStream(item.invite_timestamp)}`,
                                bottomText: `累计带来收益：¥${renderMoney(item.bring_earn)}`,
                            }}
                        />
                    ))
                }
                <Dialog type="ios" title='' buttons={[
                    { label: '知道了', onClick: () => this.setState({ isShowQuestionModal: false }) }
                ]} show={this.state.isShowQuestionModal}>
                    累计带来收益仅包含你所邀请的用户进行分销时带给你的收益，若需查看你邀请的用户进行购买时的订单，请返回上一页“分销订单”进行查看
                </Dialog>

                <WKInfiniteScroll 
                    onTouchBottom={() => this.fetchInvites()} 
                    isStop={this.state.invitesIsPending || this.props.selectId != 1} 
                    isKill={!this.state.invitesHasMore}
                    isShowLoading={true}
                />
            </div>
        )
    }
}

export default connect(state => ({
}))(ResellLiveroomPage)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellLiveroomInvites.js